
export function AdvantagesSection() {
  const advantages = [
    {
      icon: "ri-microscope-line",
      title: "Deep Upstream Exploration Expertise",
      description: "Our team brings extensive upstream exploration experience with profound understanding of the complete exploration workflow, from seismic acquisition to reservoir characterization.",
      details: [
        "Multi-year industry experience in global projects",
        "Comprehensive understanding of exploration workflows", 
        "Deep insight into industry challenges and commercial logic",
        "Proven track record in complex geological environments"
      ],
      image: "https://public.readdy.ai/ai/img_res/bf0aeffc3d62092285bbe6af54afb18a.jpg"
    },
    {
      icon: "ri-cpu-line", 
      title: "Leading Technology Integration & Innovation",
      description: "Mastery of AI, big data, HPC, and cloud computing technologies, with exceptional ability to creatively integrate these with traditional geosciences for breakthrough solutions.",
      details: [
        "Advanced AI and machine learning algorithms",
        "High-performance computing and cloud infrastructure",
        "Big data analytics and visualization platforms",
        "Innovative fusion of technology and geoscience"
      ],
      image: "https://static.readdy.ai/image/a1246d82218fb65f453dd1e18d26957d/90764f9f3489aa367ee6fe656c9c3fc8.jpeg"
    },
    {
      icon: "ri-exchange-line",
      title: "Dual-Market Driven Model",
      description: "Unique business model that deeply cultivates the energy sector while radiating technology solutions to high-tech markets, creating synergistic value across industries.",
      details: [
        "Deep energy sector specialization and expertise",
        "Cross-industry technology application capabilities", 
        "Synergistic value creation between sectors",
        "Scalable solutions for diverse market needs"
      ],
      image: "https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20interconnected%20industries%20with%20energy%20and%20technology%20sectors%2C%20network%20connections%20between%20oil%20gas%20and%20high-tech%20markets%2C%20professional%20business%20strategy%20concept%2C%20deep%20blue%20gradient%20background&width=500&height=300&seq=dualmarket&orientation=landscape"
    }
  ];

  return (
    <section id="advantages" className="py-24 bg-gradient-to-b from-slate-900/50 to-slate-800/50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-white mb-6">
            Core <strong className="text-blue-400">Advantages</strong>
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Three distinctive strengths that set us apart in the global technology landscape
          </p>
        </div>

        <div className="space-y-16">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}
            >
              {/* Image */}
              <div className="lg:w-2/5">
                <div className="relative group">
                  <img 
                    src={advantage.image}
                    alt={advantage.title}
                    className="w-full h-80 object-cover rounded-2xl shadow-2xl group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
                  
                  {/* Icon overlay */}
                  <div className="absolute top-6 left-6 w-12 h-12 bg-blue-500/80 backdrop-blur-sm rounded-xl flex items-center justify-center">
                    <i className={`${advantage.icon} text-white text-xl`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="lg:w-3/5">
                <div className="max-w-2xl">
                  <h3 className="text-3xl md:text-4xl font-light text-white mb-6">
                    {advantage.title}
                  </h3>
                  
                  <p className="text-white/80 mb-8 leading-relaxed text-lg">
                    {advantage.description}
                  </p>

                  {/* Details Grid */}
                  <div className="grid sm:grid-cols-2 gap-4">
                    {advantage.details.map((detail, detailIndex) => (
                      <div key={detailIndex} className="flex items-start gap-3 group">
                        <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 group-hover:scale-150 transition-transform duration-300"></div>
                        <span className="text-white/70 text-sm leading-relaxed group-hover:text-white/90 transition-colors duration-300">
                          {detail}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16">
          <div className="bg-gradient-to-r from-blue-600/20 to-blue-800/20 backdrop-blur-sm border border-blue-400/30 rounded-2xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-light text-white mb-4">
              Ready to Experience Our <strong className="text-blue-400">Advantages</strong>?
            </h3>
            <p className="text-white/70 mb-6 max-w-2xl mx-auto">
              Discover how our unique combination of expertise, technology, and global reach can transform your business challenges into competitive advantages.
            </p>
            <button 
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-all duration-300 font-medium whitespace-nowrap cursor-pointer"
            >
              Start Your Journey
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
